import styled from 'styled-components'
import { Collapse } from 'antd'

export const CollapseComp = styled(Collapse)`
  background-color: transparent;
  border: none;
  width: 110vh !important;
  width: ${props => (props.width ? props.width : '100%')};
  .ant-collapse-header {
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.96),
        rgba(255, 255, 255, 0.96)
      ),
      #30475e;
    border: none;
    width: 100% !important;
    border-radius: 8px !important;
    display: grid !important;
  }
  .ant-collapse-item {
    border: none;
  }
  .ant-collapse-content-box {
    padding: 0;
  }
  .ant-collapse-header-text {
    background: #ffffff !important;
  }
`
